import React, { useState, useEffect } from "react";
import { Box, TextField, Tab, CircularProgress } from "@mui/material";
import {
  East as EastIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
} from "@mui/icons-material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import {
  addCommunitymember,
  getCommunitymember,
  deleteCommitteeMember,
} from "../actions/committee.actions";
import DeleteModal from "../ui-components/DeleteModal";

const Committeemembers = () => {
  const [communityList, setCommunityList] = useState([]);

  const [firstLoading, setFirstLoading] = useState(true);
  const [loader, setLoader] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [pageNo, setPageNo] = useState(1);
  const [perPage, setPerPage] = useState(50);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPage, setTotalPage] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [searchType, setSearchType] = useState("section_qualification");
  const [pageLoader, setPageLoader] = useState(false);

  var addCommunity_default = {
    section_id: 0,
    section_title: "",
    section_title_maxlenth: 50,
    section_title_error: false,
    section_des: "",
    section_des_maxlenth: 50,
    section_des_error: false,
    section_qualification: "",
    section_qualification_maxlenth: 50,

    section_qualification_error: false,
  };

  const [addCommunity, setCommunity] = useState(addCommunity_default);
  const [value, setValue] = React.useState("1");

  const handleChange = (event, newValue) => {
    setCommunity(addCommunity_default);
    setSuccessMsg("");
    setErrorMsg("");
    setValue(newValue);
  };
  const handleChangeedit = (event, newValue) => {
    setSuccessMsg("");
    setErrorMsg("");
    setValue(newValue);
  };

  useEffect(() => {
    getCommunitymember({
      pageNo: pageNo,
      perPage: perPage,
      searchText: searchText,
      searchType: searchType,
    }).then((res) => {
      setTotalCount(res.data.pagination.totalCount);
      setTotalPage(res.data.pagination.totalPage);
      if (res.data.data.length > 0) {
        setCommunityList(res.data.data);
      } else {
        setCommunityList([]);
      }
      setFirstLoading(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const perPageChange = (e) => {
    setPerPage(e.target.value);
    setPageNo(1);
    getCommunitymember({
      pageNo: pageNo,
      perPage: perPage,
      searchText: searchText,
      searchType: searchType,
    }).then((res) => {
      setTotalCount(res.data.pagination.totalCount);
      setTotalPage(res.data.pagination.totalPage);
      if (res.data.data.length > 0) {
        setCommunityList(res.data.data);
      } else {
        setCommunityList(res.data.data);
      }
    });
  };

  const changePage = (page) => {
    if (page < 1) page = 1;
    if (page > totalPage) page = totalPage;
    setPageLoader(true);
    setPageNo(page);

    getCommunitymember({
      pageNo: pageNo,
      perPage: perPage,
      searchText: searchText,
      searchType: searchType,
    }).then((res) => {
      setTotalCount(res.data.pagination.totalCount);
      setTotalPage(res.data.pagination.totalPage);
      if (res.data.data.length > 0) {
        setCommunityList(res.data.data);
      } else {
        setCommunityList(res.data.data);
      }
      setPageLoader(false);
    });
  };

  const addCommunityInfo = (event) => {
    setSuccessMsg("");
    setErrorMsg("");

    var custInfo = { ...addCommunity };
    if (event.target.name === "section_title") {
      if (event.target.value.length <= addCommunity.section_title_maxlenth) {
        custInfo.section_title = event.target.value;
        custInfo.section_title_error = false;
      }
    }
    if (event.target.name === "section_des") {
      if (event.target.value.length <= addCommunity.section_des_maxlenth) {
        custInfo.section_des = event.target.value;
        custInfo.section_des_error = false;
      }
    }
    if (event.target.name === "section_qualification") {
      if (
        event.target.value.length <= addCommunity.section_qualification_maxlenth
      ) {
        custInfo.section_qualification = event.target.value;
        custInfo.section_qualification_error = false;
      }
    }
    setCommunity(custInfo);
  };

  const submitLocation = () => {
    // return false;
    setLoader(true);
    setSuccessMsg("");
    setErrorMsg("");
    var custInfo = { ...addCommunity };

    if (addCommunity.section_qualification === "") {
      document.getElementById("section_qualification").focus();
      custInfo.section_qualification_error = true;
      //  setErrorMsg('Please Enter Operating Unit!');
      setCommunity(custInfo);

      setLoader(false);
      return false;
    }
    if (addCommunity.section_title === "") {
      document.getElementById("section_title").focus();
      custInfo.section_title_error = true;
      //  setErrorMsg('Please Enter Operating Unit!');
      setCommunity(custInfo);

      setLoader(false);
      return false;
    }
    if (addCommunity.section_des === "") {
      document.getElementById("section_des").focus();
      custInfo.section_des_error = true;
      //  setErrorMsg('Please Enter Operating Unit!');
      setCommunity(custInfo);

      setLoader(false);
      return false;
    }

    // if (addCommunity.image_name === '') {

    //   custInfo.image_error = true;
    //   //  setErrorMsg('Please Enter Operating Unit!');
    //   setCommunity(custInfo);

    //   setLoader(false); return false;
    // }

    // if (addCommunity.image_mobile_name === '') {

    //   custInfo.image_mobile_error = true;
    //   //  setErrorMsg('Please Enter Operating Unit!');
    //   setCommunity(custInfo);

    //   setLoader(false); return false;
    // }

    const formData = new FormData();
    formData.append("section_id", addCommunity.section_id);

    formData.append("section_title", addCommunity.section_title);
    formData.append("section_des", addCommunity.section_des);
    formData.append(
      "section_qualification",
      addCommunity.section_qualification,
    );
    if (addCommunity.section_id === 0) {
      addCommunitymember(formData)
        .then((res1) => {
          if (res1.data.status === true) {
            setCommunity(addCommunity_default);
            setSuccessMsg("Community  Added Successfully!");
            getCommunitymember({
              pageNo: pageNo,
              perPage: perPage,
              searchText: searchText,
              searchType: searchType,
            }).then((res) => {
              setTotalCount(res.data.pagination.totalCount);
              setTotalPage(res.data.pagination.totalPage);
              if (res.data.data.length > 0) {
                setCommunityList(res.data.data);
              } else {
                setCommunityList([]);
              }
              setFirstLoading(false);
            });
            setLoader(false);
            setTimeout(function () {
              const startEvent = new Event("start");
              setSuccessMsg("");
              setErrorMsg("");
              handleChange(startEvent, "2");
            }, 1000);
          } else {
            setCommunity(addCommunity_default);
            setErrorMsg(res1.data.message);
            setLoader(false);
          }
        })
        .catch((error) => {
          setCommunity(addCommunity_default);
          setLoader(false);
          setErrorMsg("Something went wrong,please try again!");
        });
    } else {
      addCommunitymember(formData)
        .then((res1) => {
          if (res1.data.status === true) {
            setCommunity(addCommunity_default);

            setSuccessMsg("Community Updated Successfully!");
            getCommunitymember({
              pageNo: 1,
              perPage: perPage,
              searchText: searchText,
              searchType: searchType,
            }).then((res) => {
              setTotalCount(res.data.pagination.totalCount);
              setTotalPage(res.data.pagination.totalPage);
              if (res.data.data.length > 0) {
                setCommunityList(res.data.data);
              } else {
                setCommunityList([]);
              }
              setFirstLoading(false);
            });
            setLoader(false);
            setTimeout(function () {
              const startEvent = new Event("start");
              setSuccessMsg("");
              setErrorMsg("");
              handleChange(startEvent, "2");
            }, 1000);
          } else {
            setErrorMsg("Something went wrong,please try again!");
            setLoader(false);
          }
        })
        .catch((error) => {
          setLoader(false);
          setErrorMsg("Something went wrong,please try again!");
        });
    }
  };

  const editLocation = (e, val) => {
    var locInfo = { ...addCommunity };
    locInfo.section_id = val.section_id;

    locInfo.section_des = val.section_des;
    locInfo.section_title = val.section_title;
    locInfo.section_qualification = val.section_qualification;

    setCommunity(locInfo);

    setSuccessMsg("");
    setErrorMsg("");
    const startEvent = new Event("start");

    handleChangeedit(startEvent, "1");
  };

  const checkfilsiw = (newValue) => {
    setErrorMsg("");
    setSearchText("");
    if (newValue === "section_qualification") {
      setSearchType("section_qualification");
      document.getElementById("section_qualification").style.display = "block";
      document.getElementById("section_title").style.display = "none";
      // document.getElementById("location").style.display = 'none';
    }

    if (newValue === "section_title") {
      setSearchType("section_title");
      document.getElementById("section_title").style.display = "block";
      document.getElementById("section_qualification").style.display = "none";
      // document.getElementById("location").style.display = 'none';
    }
  };
  const checksortall = (newValue, sort) => {
    let element;
    setErrorMsg("");
    if (newValue === "section_title") {
      if (sort === "desc") {
        element = document.getElementById("section_titleasc");
        element.classList.remove("sortopacity");
        element.style.visibility = "inherit";
        element = document.getElementById("section_titledesc");
        element.classList.add("sortopacity");
        element.style.visibility = "hidden";
      }
      if (sort === "asc") {
        element = document.getElementById("section_titledesc");
        element.classList.remove("sortopacity");
        element.style.visibility = "inherit";
        element = document.getElementById("section_titleasc");
        element.classList.add("sortopacity");
        element.style.visibility = "hidden";
      }
    }

    if (newValue === "section_qualification") {
      if (sort === "desc") {
        element = document.getElementById("section_qualificationasc");
        element.classList.remove("sortopacity");
        element.style.visibility = "inherit";
        element = document.getElementById("section_qualificationdesc");
        element.classList.add("sortopacity");
        element.style.visibility = "hidden";
      }
      if (sort === "asc") {
        element = document.getElementById("section_qualificationdesc");
        element.classList.remove("sortopacity");
        element.style.visibility = "inherit";
        element = document.getElementById("section_qualificationasc");
        element.classList.add("sortopacity");
        element.style.visibility = "hidden";
      }
    }

    setFirstLoading(true);
    getCommunitymember({
      pageNo: pageNo,
      perPage: perPage,
      searchText: searchText,
      searchType: searchType,
      sort: sort,
      sortvalue: newValue,
    }).then((res) => {
      setTotalCount(res.data.pagination.totalCount);
      setTotalPage(res.data.pagination.totalPage);
      if (res.data.data.length > 0) {
        setCommunityList(res.data.data);
      } else {
        setCommunityList([]);
      }
      setFirstLoading(false);
    });
  };
  const doSearch = (e) => {
    if (e.target.name === "section_qualification") {
      setSearchText(e.target.value);
    }
    if (e.target.name === "section_title") {
      setSearchText(e.target.value);
    }
  };
  const gosubmit = (e) => {
    setErrorMsg("");

    if (searchType === "section_qualification") {
      if (searchText === "") {
        return false;
      }
    }

    if (searchType === "section_title") {
      if (searchText === "") {
        return false;
      }
    }

    setFirstLoading(true);
    getCommunitymember({
      pageNo: 1,
      perPage: perPage,
      searchText: searchText,
      searchType: searchType,
    }).then((res) => {
      setTotalCount(res.data.pagination.totalCount);
      setTotalPage(res.data.pagination.totalPage);
      if (res.data.data.length > 0) {
        setCommunityList(res.data.data);
      } else {
        setCommunityList([]);
      }
      setFirstLoading(false);
    });
  };
  const clearfilter = () => {
    setErrorMsg("");
    setSearchText("");

    setSearchType("section_title");
    setFirstLoading(true);
    document.getElementById("section_qualification").style.display = "none";
    document.getElementById("section_title").style.display = "block";
    //  document.getElementById("location").style.display='none';

    setCommunityList([]);
    getCommunitymember({
      pageNo: 1,
      perPage: perPage,
      searchText: "",
      searchType: "section_id",
    }).then((res) => {
      setTotalCount(res.data.pagination.totalCount);
      setTotalPage(res.data.pagination.totalPage);
      if (res.data.data.length > 0) {
        setCommunityList(res.data.data);
      } else {
        setCommunityList([]);
      }
      setFirstLoading(false);
    });
  };

  const resetdoc = () => {
    setSuccessMsg("");
    setErrorMsg("");
    setLoader(false);
    setCommunity(addCommunity_default);
  };

  const [deleteItem, setDeleteItem] = React.useState(null);

  const handleDelete = (item) => {
    setDeleteItem(item);
  };

  const handleDeleteSuccess = () => {
    setDeleteItem(null);
    setFirstLoading(true);
    getCommunitymember({
      pageNo: pageNo,
      perPage: perPage,
      searchText: searchText,
      searchType: searchType,
    }).then((res) => {
      setTotalCount(res.data.pagination.totalCount);
      setTotalPage(res.data.pagination.totalPage);
      setCommunityList(res.data.data);
      setFirstLoading(false);
    });
  };

  return (
    <>
      <div className="content">
        <div className="body-inner-sec">
          <div className="container-fluid">
            <div className="row">
              <div className="banner-inner-bdy-sec tab-sec-smfa">
                <Box sx={{ width: "100%", typography: "body1" }}>
                  <TabContext value={value}>
                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                      <TabList
                        onChange={handleChange}
                        aria-label="lab API tabs example"
                      >
                        <Tab
                          label={` ${addCommunity.section_id !== 0 ? "Update" : "Add"} Committee Members`}
                          value="1"
                        />
                        <Tab label="Manage Committee Members " value="2" />
                      </TabList>
                    </Box>
                    <TabPanel value="1">
                      <div className="baner-tab-add-sec">
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-secs  inner-form-secs  vali-forms">
                              <Box
                                component="form"
                                sx={{
                                  "& > :not(style)": { m: 1, width: "25ch" },
                                }}
                                noValidate
                                autoComplete="off"
                              >
                                <TextField
                                  id="section_title"
                                  label="Member Name"
                                  variant="standard"
                                  onChange={addCommunityInfo}
                                  name="section_title"
                                  value={addCommunity.section_title}
                                  error={addCommunity.section_title_error}
                                  helperText={` ${addCommunity.section_title_error === true ? "Please enter Member Name!" : ""}`}
                                />
                                <div className="charcter-sec">
                                  {addCommunity.section_title_maxlenth -
                                    addCommunity.section_title.length ===
                                  0 ? (
                                    <>
                                      <span
                                        className="char-limit"
                                        style={{ color: "#FF0000" }}
                                      >
                                        Max Character Limit reached{" "}
                                      </span>
                                    </>
                                  ) : (
                                    <>
                                      <p className="max-charact-sec">
                                        Max Characters:&nbsp;
                                        {addCommunity.section_title_maxlenth -
                                          addCommunity.section_title.length}
                                      </p>
                                    </>
                                  )}
                                </div>
                              </Box>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-secs  inner-form-secs  vali-forms">
                              <Box
                                component="form"
                                sx={{
                                  "& > :not(style)": { m: 1, width: "25ch" },
                                }}
                                noValidate
                                autoComplete="off"
                              >
                                <TextField
                                  id="section_qualification"
                                  label="Member Designation"
                                  variant="standard"
                                  onChange={addCommunityInfo}
                                  name="section_qualification"
                                  value={addCommunity.section_qualification}
                                  error={
                                    addCommunity.section_qualification_error
                                  }
                                  helperText={` ${addCommunity.section_qualification_error === true ? "Please enter Member Designation!" : ""}`}
                                />

                                <div className="charcter-sec">
                                  {addCommunity.section_qualification_maxlenth -
                                    addCommunity.section_qualification
                                      .length ===
                                  0 ? (
                                    <>
                                      <span
                                        className="char-limit"
                                        style={{ color: "#FF0000" }}
                                      >
                                        Max Character Limit reached{" "}
                                      </span>
                                    </>
                                  ) : (
                                    <>
                                      <p className="max-charact-sec">
                                        Max Characters:&nbsp;
                                        {addCommunity.section_qualification_maxlenth -
                                          addCommunity.section_qualification
                                            .length}
                                      </p>
                                    </>
                                  )}
                                </div>
                              </Box>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-secs  inner-form-secs  vali-forms">
                              <Box
                                component="form"
                                sx={{
                                  "& > :not(style)": { m: 1, width: "25ch" },
                                }}
                                noValidate
                                autoComplete="off"
                              >
                                <TextField
                                  id="section_des"
                                  label="Committee Name"
                                  variant="standard"
                                  onChange={addCommunityInfo}
                                  name="section_des"
                                  value={addCommunity.section_des}
                                  error={addCommunity.section_des_error}
                                  helperText={` ${addCommunity.section_des_error === true ? "Please enter Member Name!" : ""}`}
                                />
                                <div className="charcter-sec">
                                  {addCommunity.section_des_maxlenth -
                                    addCommunity.section_des.length ===
                                  0 ? (
                                    <>
                                      <span
                                        className="char-limit"
                                        style={{ color: "#FF0000" }}
                                      >
                                        Max Character Limit reached{" "}
                                      </span>
                                    </>
                                  ) : (
                                    <>
                                      <p className="max-charact-sec">
                                        Max Characters:&nbsp;
                                        {addCommunity.section_des_maxlenth -
                                          addCommunity.section_des.length}
                                      </p>
                                    </>
                                  )}
                                </div>
                              </Box>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <div className="button-sec">
                              <button
                                type="button"
                                className="btn btn-login btn-update"
                                onClick={(e) => {
                                  submitLocation();
                                  e.preventDefault();
                                }}
                              >
                                {addCommunity.section_id !== 0
                                  ? "Update"
                                  : "Save"}
                                {loader === true ? (
                                  <CircularProgress
                                    style={{
                                      width: "15px",
                                      height: "15px",
                                      marginLeft: "5px",
                                      color: "white",
                                    }}
                                  />
                                ) : (
                                  ""
                                )}
                              </button>
                              <button
                                type="button"
                                className="btn btn-login btn-reset"
                                onClick={(e) => {
                                  resetdoc();
                                  e.preventDefault();
                                }}
                              >
                                Reset
                              </button>
                              <div className="validate-sec">
                                {successMsg !== "" ? (
                                  <div className="">
                                    <p className="succ-msg">{successMsg}</p>
                                  </div>
                                ) : (
                                  <div className="">
                                    <p
                                      className="succ-msg"
                                      style={{ visibility: "hidden" }}
                                    >
                                      Slider Updated Successfully!
                                    </p>
                                  </div>
                                )}
                                {errorMsg !== "" ? (
                                  <div className="">
                                    <p className="error-msg">{errorMsg}</p>
                                  </div>
                                ) : (
                                  <div className="">
                                    <p
                                      className="error-msg"
                                      style={{ visibility: "hidden" }}
                                    >
                                      Something went wrong,please try again!
                                    </p>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </TabPanel>
                    <TabPanel value="2">
                      <div className="table-sec-main">
                        <div className="top-table-sec">
                          <div className="row">
                            <div className="col-md-2  entries-padd">
                              <div className="sota-table-inner">
                                <p>Show Entries</p>
                                <select
                                  className="selectsec"
                                  onChange={perPageChange}
                                  value={perPage}
                                >
                                  <option value={10}>10</option>
                                  <option value={25}>25</option>
                                  <option value={50}>50</option>
                                  <option value={100}>100</option>
                                </select>
                              </div>
                            </div>
                            <div
                              className="col-md-6"
                              style={{
                                paddingRight: "0px",
                                paddingLeft: "0px",
                              }}
                            >
                              <div className="total-count">
                                {communityList.length > 0 ? (
                                  <p>
                                    Total Committee Members{" "}
                                    <span className="number-count">
                                      {totalCount}
                                    </span>
                                  </p>
                                ) : null}
                              </div>
                              <div className="tab-manage-sec clear-sec">
                                <button
                                  className=""
                                  onClick={(e) => clearfilter()}
                                >
                                  Clear Filter
                                </button>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="filter-sec">
                                <div
                                  className="form-secs filter-form-sec"
                                  id="section_title"
                                >
                                  <Box
                                    component="form"
                                    sx={{
                                      "& > :not(style)": {
                                        m: 1,
                                        width: "25ch",
                                      },
                                    }}
                                    noValidate
                                    autoComplete="off"
                                  >
                                    <TextField
                                      id="standard-basic"
                                      label="Member Name"
                                      variant="standard"
                                      value={searchText}
                                      name="section_title"
                                      onChange={doSearch}
                                    />
                                    <EastIcon onClick={(e) => gosubmit()} />
                                  </Box>
                                </div>

                                <div
                                  className="form-secs filter-form-sec"
                                  id="section_qualification"
                                  style={{ display: "none" }}
                                >
                                  <Box
                                    component="form"
                                    sx={{
                                      "& > :not(style)": {
                                        m: 1,
                                        width: "25ch",
                                      },
                                    }}
                                    noValidate
                                    autoComplete="off"
                                  >
                                    <TextField
                                      id="standard-basic"
                                      label="Committee Name"
                                      variant="standard"
                                      value={searchText}
                                      name="section_des"
                                      onChange={doSearch}
                                    />
                                    <EastIcon onClick={(e) => gosubmit()} />
                                  </Box>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="form-table-sec">
                            <div className="row">
                              <div className="col-md-12">
                                <table className="table table-bordered">
                                  <thead>
                                    <tr className="tab-head-sec">
                                      <th className="admin-sl  serial-sec">
                                        Sl No
                                      </th>
                                      <th
                                        className="label-sec"
                                        onClick={(e) =>
                                          checkfilsiw("section_title")
                                        }
                                      >
                                        Member Name
                                        <span
                                          className="top-sort "
                                          id="section_titledesc"
                                        >
                                          <i
                                            className="fa-solid fa-sort-up"
                                            onClick={(e) =>
                                              checksortall(
                                                "section_title",
                                                "desc",
                                              )
                                            }
                                          ></i>
                                        </span>
                                        <span
                                          className="bottom-sort  sortopacity"
                                          id="section_titleasc"
                                        >
                                          <i
                                            className="fa-solid fa-sort-down"
                                            onClick={(e) =>
                                              checksortall(
                                                "section_title",
                                                "asc",
                                              )
                                            }
                                          ></i>
                                        </span>
                                      </th>
                                      <th
                                        className="tit-sec"
                                        onClick={(e) =>
                                          checkfilsiw("section_qualification")
                                        }
                                      >
                                        Member Designation
                                        <span
                                          className="top-sort "
                                          id="section_qualificationdesc"
                                        >
                                          <i
                                            className="fa-solid fa-sort-up"
                                            onClick={(e) =>
                                              checksortall(
                                                "section_qualification",
                                                "desc",
                                              )
                                            }
                                          ></i>
                                        </span>
                                        <span
                                          className="bottom-sort  sortopacity"
                                          id="section_qualificationasc"
                                        >
                                          <i
                                            className="fa-solid fa-sort-down"
                                            onClick={(e) =>
                                              checksortall(
                                                "section_qualification",
                                                "asc",
                                              )
                                            }
                                          ></i>
                                        </span>
                                      </th>
                                      <th className="para-sec">
                                        Committee Name
                                      </th>
                                      <th className="action-sec">Action</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {firstLoading ? (
                                      <tr className="td-sec">
                                        <td colSpan={8}>
                                          <div
                                            className="spinner-border"
                                            role="status"
                                            style={{
                                              width: "1rem",
                                              height: "1rem",
                                              marginLeft: "6px",
                                            }}
                                          ></div>
                                        </td>
                                      </tr>
                                    ) : (
                                      <>
                                        {communityList.length > 0 ? (
                                          communityList.map((userd, index) => (
                                            <tr
                                              key={index}
                                              className="tab-data-sec"
                                            >
                                              <td className="tab-border-left">
                                                {pageNo * perPage -
                                                  perPage +
                                                  1 +
                                                  index}
                                              </td>
                                              <td>{userd.section_title}</td>
                                              <td>
                                                {userd.section_qualification}
                                              </td>
                                              <td>{userd.section_des}</td>

                                              <td className="edit-sec">
                                                <EditIcon
                                                  onClick={(e) =>
                                                    editLocation(e, userd)
                                                  }
                                                />
                                                <DeleteIcon
                                                  onClick={() =>
                                                    handleDelete(userd)
                                                  }
                                                  className="del-admn-sec"
                                                />
                                              </td>
                                            </tr>
                                          ))
                                        ) : (
                                          <tr>
                                            <td colSpan={8}>No Data Found</td>
                                          </tr>
                                        )}
                                      </>
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>

                          {/* pagination start */}
                          {totalPage > 1 ? (
                            <>
                              {pageLoader ? (
                                <div
                                  className="spinner-border"
                                  role="status"
                                  style={{
                                    width: "1rem",
                                    height: "1rem",
                                    marginLeft: "6px",
                                    float: "right",
                                    position: "absolute",
                                    bottom: "73px",
                                    right: "35px",
                                  }}
                                ></div>
                              ) : (
                                ""
                              )}

                              <div
                                className="pagination-sec"
                                style={{
                                  boxShadow: "#e29a1217 0px 7px 16px 0px",
                                  width: "auto",
                                  float: "right",
                                  border: "1px solid #0cb8b6",
                                  marginTop: "2px",
                                  marginRight: "20px",
                                  height: "40px",
                                }}
                              >
                                <div
                                  style={{
                                    float: "left",
                                    padding: "0px",
                                    color: "rgb(11, 92, 171)",
                                    fontSize: "14px",
                                    width: "100%",
                                    position: "relative",
                                    display: "inline-flex",
                                  }}
                                >
                                  <div className="pagin-sec">
                                    <i
                                      className="fa-solid fa-angle-left"
                                      onClick={(e) => changePage(pageNo - 1)}
                                      style={{
                                        float: "left",
                                        marginTop: "10px",
                                        marginLeft: "9px",
                                        marginRight: "10px",
                                        cursor: "pointer",
                                        fontSize: "18px",
                                        color: "#E29A12",
                                      }}
                                    ></i>
                                    <span
                                      className="go-sec"
                                      style={{
                                        float: "left",
                                        fontSize: "15px",
                                        marginTop: "9px",
                                        marginLeft: "1px",
                                        marginRight: "1px",
                                        color: "rgb(114, 114, 114)",
                                      }}
                                    >
                                      Go to{" "}
                                    </span>
                                    <input
                                      className="number-secs"
                                      type="number"
                                      value={pageNo}
                                      onChange={(e) => {
                                        !isNaN(parseInt(e.target.value)) &&
                                        parseInt(e.target.value) > 0
                                          ? changePage(parseInt(e.target.value))
                                          : changePage(1);
                                      }}
                                      style={{
                                        color: "rgb(0, 23, 55)",
                                        margin: "9px 6px 0px 4px",
                                        fontSize: "14px",
                                        width: "34px",
                                        height: "22px",
                                        float: "left",
                                        textAlign: "center",
                                        border: "1px solid rgb(114, 114, 114)",
                                        borderRadius: "3px",
                                        outline: "none",
                                      }}
                                    />
                                    <span
                                      className="go-sec"
                                      style={{
                                        float: "left",
                                        fontSize: "15px",
                                        marginTop: "9px",
                                        marginLeft: "2px",
                                        marginRight: "2px",
                                        color: "rgb(114, 114, 114)",
                                      }}
                                    >
                                      of {totalPage}{" "}
                                    </span>
                                    <i
                                      className="fa-solid fa-angle-right"
                                      onClick={(e) => changePage(pageNo + 1)}
                                      style={{
                                        float: "left",
                                        marginTop: "10px",
                                        marginRight: "6px",
                                        marginLeft: "5px",
                                        cursor: "pointer",
                                        fontSize: "20px",
                                        color: "#E29A12",
                                      }}
                                    ></i>
                                  </div>
                                </div>
                              </div>
                            </>
                          ) : (
                            ""
                          )}
                          {/* pagination end */}
                        </div>
                      </div>
                    </TabPanel>
                  </TabContext>
                </Box>
              </div>
            </div>
          </div>
        </div>
      </div>

      <DeleteModal
        open={deleteItem !== null}
        title={"Delete Committee Member"}
        message={"Are you sure you want to delete this Committee Member?"}
        handleClose={() => setDeleteItem(null)}
        handleSuccess={handleDeleteSuccess}
        deleteAction={deleteCommitteeMember}
        data={deleteItem ? { section_id: deleteItem.section_id } : null}
      />
    </>
  );
};

export default Committeemembers;
